export default __webpack_public_path__ + "src/assets/tasks/enig/Enig_med_Omar_avslut.mp3";